import classes from './ColumnGrid.module.css';
import * as React from 'react';
import { useExpandedColumns, useReleases } from '../../state/context';
import classNames from 'classnames';
import { COLLAPSED_COLUMN_WIDTH, COLUMNS_START_PADDING, EXPANDED_COLUMN_WIDTH } from '../../layout';

type ColumnGridProps = {
  excludeLeftPadding?: boolean;
};

const ColumnGrid = ({ excludeLeftPadding }: ColumnGridProps) => {
  const releases = useReleases();
  const [expandedColumns] = useExpandedColumns();
  const stripes = React.useMemo(() => {
    let left = excludeLeftPadding ? 0 : COLUMNS_START_PADDING;
    const stripes: React.ReactElement[] = [];

    releases.forEach((release) => {
      const isExpanded = expandedColumns.includes(release.id);
      if (isExpanded) {
        stripes.push(
          <div
            key={release.id}
            className={classNames([
              classes['stripe'],
              classes['expanded'],
            ])}
            style={{
              left: left + 8,
              width: EXPANDED_COLUMN_WIDTH - 16
            }}
          />
        );

        left += EXPANDED_COLUMN_WIDTH;
      } else {

        stripes.push(
          <div
            key={release.id}
            className={classes['stripe']}
            style={{
              left: left + 8,
              width: COLLAPSED_COLUMN_WIDTH - 16
            }}
          />
        );

        left += COLLAPSED_COLUMN_WIDTH;
      }
    });

    return stripes;
  }, [releases, expandedColumns]);

  return (
    <div className="pointer-events-none">
      {stripes}
    </div>
  );
};

export default ColumnGrid;
